<template>
    <div class="container">
        <div class="grid grid-cols-12">
            <div class="col-span-12 lg:col-start-2 lg:col-span-10">
                <SectionIntro
                    :title="$t('menu.contact')"
                    class="mb-12 lg:mb-24 mt-14"
                    :subtitle="$t('contact.subtitle')"
                    lg
                />
            </div>
            <div class="col-span-12 lg:col-start-2 lg:col-span-5 lg:pt-14">
                <h2 class="font-Inter-Bold text-lg lg:text-xl mb-8">{{ $t('contact.form_title') }}</h2>
                <ContactForm class="mb-9 lg:mb-12 sm:px-10 lg:px-0" />
            </div>
            <div
                class="col-span-12 lg:col-span-6 pt-8 lg:pt-14 lg:ml-20 px-4 sm:px-10 bg-black bg-opacity-[2%] rounded-xl mb-16 lg:mb-0"
            >
                <h2 class="font-Inter-Bold text-lg lg:text-xl mb-8">{{ $t('contact.in_person_title') }}</h2>
                <div class="flex flex-col gap-y-4 mb-12 lg:mb-16">
                    <div class="flex items-center">
                        <i class="ri-mail-line mr-4 text-lg"></i
                        ><span class="block font-Inter-Semibold text-sm">hello@kartapolis.hu</span>
                    </div>
                    <div class="flex items-center">
                        <i class="ri-phone-line mr-4 text-lg"></i
                        ><span class="block font-Inter-Semibold text-sm">06 (30) 938 8835</span>
                    </div>
                    <div class="flex items-center">
                        <i class="ri-map-pin-line mr-4 text-lg"></i
                        ><span class="block font-Inter-Semibold text-sm"
                            >4400 Nyíregyháza, Ady Endre utca 15 3/11.</span
                        >
                    </div>
                </div>
                <h2 class="font-Inter-Bold text-lg lg:text-xl mb-8">{{ $t('contact.business.title') }}</h2>
                <p class="mb-10 text-sm">
                    <strong class="mb-4 block leading-5">{{ $t('contact.business.lead') }}</strong>
                    <span class="leading-5">
                        {{ $t('contact.business.text') }}
                    </span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import ContactForm from '../components/Forms/ContactForm';

export default {
    name: 'Contact',
    components: {
        ContactForm,
    },
};
</script>
